"use client";

import { RetrievedJobPosition } from "@/lib/sanity/responseTypes";
import { useLocale, useTranslations } from "next-intl";

import ChevronUp from "@/components/icons/chevron-up.svg";
import ChevronDown from "@/components/icons/chevron-down.svg";
import { useState } from "react";
import { PortableText } from "@portabletext/react";

interface JobPostingsProps {
  jobPostings: RetrievedJobPosition[];
}

export default function JobPostings(props: JobPostingsProps) {
  const t = useTranslations('About');
  const locale = useLocale();

  const { jobPostings } = props;

  function JobPostingItem(props: { job: RetrievedJobPosition }) {
    const { job } = props;
    const [isOpen, setIsOpen] = useState<boolean>(false);

    function toggleOpen() {
      setIsOpen(!isOpen);
    }

    return (
      <div className="w-full max-w-[1080px] flex flex-col border-b-1 border-accent p-2.5 gap-2.5 scroll-mt-[60px]">
        <div onClick={toggleOpen} className="flex flex-row gap-x-1.5 lg:gap-x-[26px] justify-center items-center cursor-pointer">
          <div className="font-bold text-lg lg:text-[32px] text-center leading-[120%]">{job.jobTitle}</div>
          {isOpen ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />}
        </div>
        {isOpen ? (
          <>
            <PortableText value={job.description} />
            <div className="w-full text-center h-[42px] flex flex-col justify-center items-center">
              <span>
                {t('jobpostings_applyTo')} {job.contact.email || job.contactEmail || "info@invento.ch"}
              </span>
            </div>
          </>
        ) : null}
      </div>
    )
  }

  return (
    <div id="karriere" className="flex flex-col w-full pt-20 px-2.5 gap-[30px] text-primary font-[Outfit] items-center">
      <div className="font-bold text-5xl leading-[120%] w-full text-center">
        {t('jobpostings_title')}
      </div>
      <div className="w-full flex flex-col items-center py-6">
        {jobPostings.map((j, i) => (
          <JobPostingItem key={`job-${i}`} job={j} />
        ))}
      </div>

    </div>
  )

}
